<template>
  <div class="inputLabelArea">
    <label
      class="inputLabel"
      :class="{
        required: required,
        optional: optional,
        isPc: !isSp,
        isHasLabel: !isSp && (required || optional),
        rightSpace: rightSpace,
        isPcModal: isPcModal,
        isSotsunen: isSotsunen,
      }"
    >
      <slot></slot>
    </label>
  </div>
</template>

<script>
export default {
  name: 'InputLabel',
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    optional: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSpFlg: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    rightSpace: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    /**
     * 資料請求確認画面PC、 予約確認画面PCの時のみtrue
     * 両画面の変更フォームをモーダル内に表示する際にスタイル調整するため。
     */
    isPcModal: {
      type: Boolean,
      required: false,
      default: undefined,
    },
    isSotsunen: {
      type: Boolean,
      required: false,
      default: undefined,
    },
  },
  computed: {
    isSp() {
      if (typeof this.isSpFlg === 'boolean') return this.isSpFlg;
      return this.$isSp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'css/contents/common/global';

@mixin badgeBase() {
  display: inline-block;
  margin-left: 8px;
  height: 20px;
  border-radius: 4px;
  padding: 0 6px;
  font-size: $text-size-caption1;
  line-height: 20px;
  color: #fff;
}

@mixin pcBadgePosition() {
  position: absolute;
  text-align: center;
  left: 116px;
  width: 24px;
  top: 50%;
  transform: translate(0, -50%);
}

.inputLabelArea {
  font-size: 0;

  .inputLabel {
    display: block;
    font-weight: $text-weight-bold;
    line-height: $text-line-height-default;
    color: $color-text-secondry;
    font-size: $text-size-paragraph2;
    margin-bottom: 8px;

    &.isPc {
      position: relative;
      width: 115px;
      margin: 0;

      &.isSotsunen {
        width: 65px;
      }
    }

    &.required {
      &::after {
        @include badgeBase;

        content: '必須';
        background: #de30ca;
        white-space: nowrap;
      }
    }

    &.optional {
      &::after {
        @include badgeBase;

        content: '任意';
        background: #afb8be;
        white-space: nowrap;
      }
    }

    &.isHasLabel.isPc {
      &.required {
        &::after {
          @include pcBadgePosition;
        }
      }

      &.optional {
        &::after {
          @include pcBadgePosition;
        }
      }

      &.isPcModal::after {
        left: 80px;
        margin-left: 0;
        line-height: 1.5;
      }
    }

    &.rightSpace {
      padding-right: 8px;
    }
  }
}
</style>
